import { FunnelIcon as PhosphorFunnelIcon } from "@phosphor-icons/react/dist/ssr/Funnel";

import { createAppIcon } from "@/components/createAppIcon";

export const FilterIcon = /* @__PURE__ */ createAppIcon(PhosphorFunnelIcon);
